<div class="shui"></div>
<app-dialog dialogId="logout-dialog" heading="Log Out?">
    <ng-template>
        Are you sure you want to Log Out?

        <div class="button-row">
            <button type="button" class="btn btn-secondary" (click)="closeLogoutDialog()">Cancel</button>
            <app-wait-button (click)="logout()" [waiting]="submitting" label="Log Out"></app-wait-button>
        </div>
    </ng-template>
</app-dialog>

<app-dialog dialogId="exit-dialog" heading="Exit?">
    <ng-template>
        Please close your browser window to exit Sircon.

        <div class="button-row">
            <button type="button" class="btn btn-verty" (click)="closeExitDialog()">Ok, Got It</button>
        </div>
    </ng-template>
</app-dialog>

